/**
 * Foundation colour primitives used by self-signup.
 *
 * Copied as literals from connect-desktop `master:reconnect/src/federation/tokens/_foundation.css`
 * (light theme), the palette Connect moved to in CPG-779/778/808. Literals rather than CSS vars
 * because self-signup has no runtime dependency on Reconnect's token CSS (same trade-off as
 * Connect Layer 1). Re-sync from that file if the foundation palette changes.
 * Only the steps self-signup actually uses are included.
 */
export const FoundationColors = {
  blue: {
    100: '#E8EEFE',
    200: '#D1DEFC',
    400: '#749BF7',
    600: '#1859F1',
    700: '#1347C1',
    800: '#0E3591',
  },
  grey: {
    300: '#E4E7F0',
    500: '#B4BBCA',
    800: '#626F8C',
  },
  white: '#FFFFFF',
} as const;
